export default __webpack_public_path__ + "static/media/IMG_1006.08358fe1.JPG";